import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Layout, Breadcrumb, Table, Button, Divider, Form, Row, Col, Space, Popconfirm, message, Avatar, Tag
} from 'antd';
import {
    HomeOutlined, PlusOutlined, EditOutlined, DeleteOutlined
} from '@ant-design/icons';

import * as Service from '../../../config/service';
import CONSTANT from '../../../config/constant';


const DoctorCategory = (props) => {
    const [form] = Form.useForm();
    // define column table
    const columns = [
        {
            title: 'Ảnh', dataIndex: 'avatar',
            render: avatar => avatar && <Avatar size={48} shape="square" src={`${CONSTANT.STATIC_URL}${avatar}`} />,
            width: '50px'
        },
        { title: 'Tên', dataIndex: 'name' },
        { 
            title: 'Trạng thái', dataIndex: 'is_active', width: '150px',
            render: is_active => <Tag color={`${is_active ? 'green' : 'red'}`}>{is_active ? 'Hoạt động' : 'Bản nháp'}</Tag>
        },
        {
            title: 'Hành động', width: '180px',
            render: (text, record) => (
                <Space size="middle">
                    <Link to={`/doctor/category/edit/${record._id}`}><EditOutlined /> Sửa</Link>
                    <Divider type="vertical" />
                    <Popconfirm title="Bạn có chắc xóa?" onConfirm={() => handleDelete(record._id)}>
                        <a href="#"><DeleteOutlined /> Xóa</a>
                    </Popconfirm>
                </Space>
            )
        }
    ];
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pagination, _] = useState({ current: 1, pageSize: -1 });

    const fetch = async (params = {}) => {
        setLoading(true);

        await Service.get(`${CONSTANT.API.DOCTOR.CATEGORY}`, { is_parent: true, perPage: -1, is_deleted: false, page: 1 })
            .then(res => {
                if (res && res.data && res.data.code === 200) {
                    if (res?.data?.data.docs.length > 0) {
                        let { docs } = res.data.data;
                        for (let lv1 of docs) {
                            if (lv1?.childs?.length > 0) {
                                lv1.children = lv1.childs;
                            }
                        }
                        setData(docs);
                    }

                    setLoading(false);
                }

            })
    }


    const handleDelete = async (key) => {
        if (key) {
            await Service.remove(`${CONSTANT.API.DOCTOR.CATEGORY}/${key}`)
                .then((res) => {
                    if (res && res.data && res.data.code === 200) {
                        message.success('Xóa thành công!');
                        fetch({ pagination });
                    }
                    else {
                        message.error('Xóa không thành công');
                    }
                })
                .catch(err => message.error('Xóa không thành công'))
        }
    }

    useEffect(() => {
        fetch({ pagination })
    }, []);

    return (
        <div>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item >
                    <Link to="/"><HomeOutlined /></Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    Danh mục chuyên môn
                </Breadcrumb.Item>
            </Breadcrumb>
            <Layout.Content className="layout-content">

                <Row justify="end" style={{ marginBottom: 20 }}>
                    <Col>
                        <Button type="primary" icon={<PlusOutlined />} onClick={() => props.history.push('/doctor/category/add')} >
                            Thêm mới
                        </Button>
                    </Col>
                </Row>

                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={false}
                    rowKey={record => record._id}
                    expandable={{
                        defaultExpandAllRows: true
                    }}
                    key="list"
                />
            </Layout.Content>
        </div>
    )
}

export default DoctorCategory;
